<script>
export default {
  props: { id: { required: true } },

  created() {
    this.refresh()
  },

  data() {
    return {
      loading: true
    }
  },

  computed: {
    eligibility() {
      return this.$store.getters['admin/eligibilities/find'](this.id)
    }
  },

  methods: {
    refresh() {
      return this.$store.dispatch('admin/eligibilities/fetch', this.id).then(
        () => (this.loading = false),
        errors => {
          this.loading = false
          this.$store.dispatch('snackbarError', 'Eligibility not Found')
          this.$emit('close')
        }
      )
    }
  },

  render() {
    return this.$scopedSlots.default({
      eligibility: this.eligibility,
      loading: this.loading
    })
  }
}
</script>
